export default function download(data, filename) {
  import('downloadjs').then(mod => {
    const func = mod.default
    func(data, filename)
  })
}
